<template>
  <div class="LinkWP disabled" :style="inputStyle" v-if="link.disable">
    <div class="before" v-if="isBefore"></div>
    <div :title="'不在比赛时间内'">{{link.text}}</div>
    <div class="after" v-if="!isBefore"></div>
  </div>
  <div class="LinkWP" :style="inputStyle" @click="navigate" v-else>
    <div class="before" v-if="isBefore"></div>
    <div class="link"> {{link.text}}</div>
    <div class="after" v-if="!isBefore"></div>
  </div>
  
</template>

<script>
 export default {
   name: '',
   props: [
     'link',
     'inputStyle',
     'isBefore'
   ],
   methods: {
     navigate () {
       this.$router.push(this.link.link)
     }
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .LinkWP{
   display: flex;
   align-items:center;
   justify-content:space-between;
   cursor: pointer;
 }
 .link {
   display: flex;
   justify-content: center;
   align-items: center;
   color: #3a3a3a;
 }
 .before{
   height: 0.78vw;
   width: .47vw;
   background-image: url(~@/assets/image/account/before.png);
   background-size: 0.47vw 0.78vw;
   background-position: center;
   margin-right: 0.573vw;
 }
.after{
   height: 0.78vw;
   width: .47vw;
   background-image: url(~@/assets/image/account/after.png);
  background-size: 0.47vw 0.78vw;
   margin-left: 0.573vw;
 }
 .disabled{
   cursor: not-allowed !important;
 }
 
 @media (min-width: 320px) and (max-width: 480px) {
   .before{
     height: 1em;
     width: 0.6em;
   background-size: 0.6em 1em;
     margin-right: 0.5em;
   }
   .after{
     height: 1em;
     width: 0.6em;
   background-size: 0.6em 1em;
     margin-left: 0.5em;
   }
 }
</style>
